import { type ScreenDefinitionControlAttributes } from './generated/ScreenDefinitionControlAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface ScreenDefinitionControl extends ScreenDefinitionControlAttributes {}

@model
class ScreenDefinitionControl extends ApplicationModel {
  // Start auto-generated
  static typename: 'ScreenDefinitionControl' = 'ScreenDefinitionControl';
  get typename(): 'ScreenDefinitionControl' {
    return 'ScreenDefinitionControl';
  }

  static internalTypename: 'ScreenDefinitionControl' =
    'ScreenDefinitionControl';
  get internalTypename(): 'ScreenDefinitionControl' {
    return 'ScreenDefinitionControl';
  }

  static fields = {
    fieldId: attr({ readable: true }),
    id: attr({ readable: true }),
    readOnly: attr({ readable: true }),
    required: attr({ readable: true }),
    customFieldDefinition: attr.belongsTo({
      readable: true,
      typename: 'CustomFieldDefinition',
    }),
  };
  // End auto-generated
}

export default ScreenDefinitionControl;
